import { createElement, useEffect, useRef } from 'react';
import type { HTMLAttributes } from 'react';

interface WeaveSliderProps extends Omit<HTMLAttributes<HTMLElement>, 'onChange'> {
  min?: number;
  max?: number;
  step?: number;
  value?: number;
  disabled?: boolean;
  density?: 'high' | 'medium';
  onChange?: (event: unknown) => void;
  // Event type for onChange: { nativeEvent?: { detail?: string } }
}

export function WeaveSlider({
  min = 0,
  max = 100,
  step = 1,
  value,
  disabled,
  density = 'high',
  onChange,
  ...rest
}: WeaveSliderProps) {
  const sliderRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (!sliderRef.current) {
      return;
    }

    sliderRef.current.setAttribute('min', String(min));
    sliderRef.current.setAttribute('max', String(max));
    sliderRef.current.setAttribute('step', String(step));

    if (value !== undefined) {
      sliderRef.current.setAttribute('value', String(value));
      (sliderRef.current as unknown as { value?: number }).value = value;
    }
  }, [min, max, step, value]);

  return createElement('weave-slider', {
    disabled,
    density,
    ref: (node: HTMLElement | null) => {
      sliderRef.current = node;
    },
    onChange: (event: unknown) => {
      onChange?.(event);
    },
    onInput: (event: unknown) => {
      onChange?.(event);
    },
    ...rest,
  });
}
